import { render } from "./HomePage.vue?vue&type=template&id=25d494a8"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=25d494a8&lang=css"

import exportComponent from "/builds/christinandrea/kel1-kedaireka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__